export const skillsData = [
  {
    title: "A.I. Tools",
    icon: "🤖",
    category: "ai-tools",
    special: true,
    skills: [
      {
        name: "ChatGPT",
        level: 90,
        description: "Advanced prompting, code generation",
      },
      {
        name: "Claude",
        level: 90,
        description: "Technical discussions, analysis",
      },
      { name: "GitHub Copilot", level: 78, description: "AI-assisted coding" },
      { name: "Figma", level: 65, description: "Design automation" },

      // { name: "Midjourney", level: 82, description: "AI image generation" },
      // { name: "Cursor IDE", level: 85, description: "AI-powered development" },
    ],
  },
  {
    title: "Languages",
    icon: "💻",
    category: "programming",
    skills: [
      {
        name: "HTML5",
        level: 92,
        description: "Semantic markup",
      },
      { name: "CSS3", level: 84, description: "Flexbox, Grid, SASS" },
      { name: "JavaScript", level: 80, description: "ES6+, DOM manipulation" },
      {
        name: "TypeScript",
        level: 60,
        description: "Type checking, interfaces",
      },
      { name: "Python", level: 18, description: "Scripting, Basics" },
    ],
  },
  {
    title: "Technologies",
    icon: "⚙️",
    category: "technologies",
    skills: [
      {
        name: "React",
        level: 90,
        description: "Next.js, Redux, RQuery",
      },
      {
        name: "Responsive Design",
        level: 90,
        description: "Mobile-first approach",
      },
      {
        name: "Browser DevTools",
        level: 88,
        description: "Debugging, performance",
      },
      { name: "Git & GitHub", level: 82, description: "Version control" },
      { name: "Web APIs", level: 78, description: "Fetch, localStorage" },
    ],
  },
  {
    title: "Other Skills",
    icon: "🌍",
    category: "other",
    skills: [
      {
        name: "Problem Solving",
        level: 90,
        description: "Analytical thinking,",
      },
      {
        name: "English",
        level: 90,
        description: "C1, Academic",
      },
      {
        name: "German",
        level: 90,
        description: "C1, Telc-C1 Hochschule Certified",
      },

      {
        name: "Communication",
        level: 70,
        description: "Team player, collabrative",
      },
    ],
  },
];
